import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'
import type { ButtonHTMLAttributes } from 'react'
import { forwardRef } from 'react'

export const badgeStyle = cva(
    [
        'w-fit flex items-center justify-center px-[6px] border-0.5 rounded-2 text-xxs h-[20px] leading-0 whitespace-nowrap'
    ],
    {
        variants: {
            intent: {
                default: 'bg-backgroundNeutralLight text-textPrimary border-borderPrimary',
                warning: 'bg-backgroundWarningLight text-textWarning border-borderWarning',
                negative: 'bg-backgroundNegativeLight text-textNegativeSecondary border-borderNegative',
                positive: 'bg-backgroundPositiveLight text-textPositive border-borderPositive',
                information: 'bg-backgroundInformationLight text-textInformation border-borderInformation',
                purple: 'bg-backgroundPurple text-textExtraPurple border-borderPurple',
                negativeSecondary: 'bg-backgroundNegativeStrong text-textNegativeSecondary border-borderNegative',
                warningSecondary: 'bg-backgroundWarningStrong text-textWarning border-borderWarning'
            }
        },
        defaultVariants: {
            intent: 'default'
        }
    }
)

export type BadgeProps = ButtonHTMLAttributes<HTMLButtonElement> & VariantProps<typeof badgeStyle>

const Badge = forwardRef<HTMLSpanElement, BadgeProps>(({ className, intent, ...props }, forwardRef) => {
    return (
        <span
            ref={forwardRef}
            className={badgeStyle({
                intent,
                className
            })}
            {...props}
        />
    )
})

export default Badge
